module.exports = __webpack_public_path__ + "static/stamp-failed.5b4e9301.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/site/stamp-failed.png
// module id = 762
// module chunks = 35783957827783 94702618338223